import { Badge, Flex, Menu, Typography } from 'antd';
import { useSelector } from 'react-redux';

const { Item } = Menu;
const { Text } = Typography;
// Define colors for styling
const defaultIconColor = '#8C8C8C'; // Gray
const selectedIconColor = '#00A85A'; // Dark Green
const selectedTextColor = '#00A85A'; // Dark Green
const selectedBgColor = '#E6F7EE'; // Light Green

const TeamsList = ({ Icon, name, isSelected, onClick, ...rest }) => {
  const { wc_es } = useSelector((state) => state.inbox);

  return (
    <Item
      key={rest.team_id}
      icon={
        Icon && (
          <Icon color={isSelected ? selectedIconColor : defaultIconColor} />
        )
      }
      className="hover:bg-gray-200"
      onClick={() => onClick(rest)}
      style={{
        backgroundColor: isSelected && selectedBgColor,
        borderRadius: '6px',
        margin: '4px 0',
        paddingLeft: '1.5rem',
      }}
    >
      <Flex justify="space-between" align="center">
        <Text
          style={{
            color: isSelected ? selectedTextColor : 'inherit',
          }}
          className="text-gray-500 group-hover:text-black text-xs ms-3 w-[70%] overflow-hidden text-ellipsis"
        >
          {name}
        </Text>
        <Badge
          count={wc_es[`team_${rest.team_id}`]?.newMessageNotificationCount}
        />
      </Flex>
    </Item>
  );
};

export default TeamsList;
